import dateFilterTypes from '@/constant/date-filter-types'

export default (dateFilter, form = 'YYYY-MM-DD') => {
  /*eslint-disable*/
  const type = dateFilter.value < 100 ? dateFilterTypes.find(item => item.value < 10) : dateFilterTypes.find(item => item.value == dateFilter.value)
  /*eslint-enable*/
  return type.fn(dateFilter.value, form)
}
